import { render, staticRenderFns } from "./video-landscape.vue?vue&type=template&id=0b92a7e3&scoped=true&"
import script from "./video-landscape.vue?vue&type=script&lang=js&"
export * from "./video-landscape.vue?vue&type=script&lang=js&"
import style0 from "./video-landscape.vue?vue&type=style&index=0&id=0b92a7e3&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b92a7e3",
  null
  
)

export default component.exports